import styled from 'styled-components';
import { Badge } from '@prisjakt/ui/badge';

export const ButtonBadge = styled(Badge)`
  background-color: ${p => p.theme.colors.maybeBlue500};
  position: absolute;
  top: -30%;
  right: -12px;

  > span {
    color: ${p => p.theme.colors.base0};
  }
`;
